import { useState } from 'react';
import { useAuthContext } from 'contexts/Auth';
import { useForm, UseFormMethods } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { apiFetch } from 'services/apiFetch';
import { setToken } from 'services/auth';
import yup from 'utils/yup';

type UseFormType = Partial<Pick<UseFormMethods, 'register' | 'errors' | 'setError'>> & {
  onSubmit: () => void,
  loading: boolean,
};

const schema = yup.object().shape({
  password: yup.string()
    .required()
    .label('Senha'),
});

export default (
  { afterSubmit }:{ afterSubmit: () => void },
):UseFormType => {
  const { email, setName } = useAuthContext();
  const [loading, setLoading] = useState(false);

  const {
    register, handleSubmit, errors, setError,
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = handleSubmit(async (formData) => {
    setLoading(true);

    const response = await apiFetch('/session', {
      method: 'POST',
      body: JSON.stringify({ email, password: formData.password }),
    });

    if (response.ok) {
      const data = await response.json() as {
        id: number, name: string, email: string, token: string,
      };
      setToken(data.token);
      setName(data.name);
      afterSubmit();
    } else {
      setError('password', {
        type: 'check-login',
        message: 'Impossível fazer login com as credenciais fornecidas.',
      });
    }

    setLoading(false);
  });

  return {
    register,
    errors,
    setError,
    loading,
    onSubmit,
  };
};
